import React from 'react';
import useTenant from '../hooks/useTenant';

export default function TenantDashboard() {
  const { tenantId, tenant } = useTenant();

  if (!tenant) {
    return (
      <div className="p-6 text-red-600">
        ⚠️ Tenant not found for ID: <strong>{tenantId}</strong>. Please check the URL or login
        context.
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex items-center space-x-4 mb-4">
        {tenant.logo && (
          <img src={tenant.logo} alt={`${tenant.name} logo`} className="h-10 w-auto" />
        )}
        <h1 className="text-2xl font-bold" style={{ color: tenant.color }}>
          {tenant.name} Dashboard
        </h1>
      </div>

      <p className="text-gray-700">
        This interface is scoped to tenant <strong>{tenantId}</strong>. You can now display
        tenant-specific data, branding, and modules here.
      </p>
    </div>
  );
}
